// extracted by mini-css-extract-plugin
export default {"grid":"grid_qo2Te3G3","image":"image_iUZWtXod"};